<template>
  <div class="sso-buttons">
    <GoogleSignOn />
    <!-- <FacebookSignOn /> -->
  </div>
</template>

<script>
import GoogleSignOn from "@/components/GoogleSignOn.vue";
// import FacebookSignOn from "@/components/FacebookSignOn.vue";

export default {
  name: "SingleSignOn",
  components: {
    GoogleSignOn,
    // FacebookSignOn,
  },
};
</script>

<style lang="scss" scoped>
.sso-buttons {
  padding: 5px 20px 30px;
  margin-bottom: 20px;
  margin-left: -20px;
  margin-right: -20px;
  border-bottom: 1px solid rgba($color-dark, 0.2);
}
</style>
